
import { useQuery } from "@tanstack/react-query";
import { getUserProfile } from "../../API/ProtectedAuth";
import { handleApiError } from "../../Utils/errorHandler";

const useProfile = () => {
  const {
    data: profile,
    error,
    isLoading: loading,
    refetch: refreshProfile,
  } = useQuery({
    queryKey: ["userProfile"],
    queryFn: async () => {
      try {
        return await getUserProfile();
      } catch (err) {
        handleApiError(err);
        throw err;
      }
    },
    staleTime: 1000 * 60 * 60, 
    cacheTime: 1000 * 60 * 60 * 12, 
    refetchOnWindowFocus: false,
  });

  return { profile, loading, error, refreshProfile };
};

export default useProfile;




















      


      




























